module.exports = __webpack_public_path__ + "static/media/Vendas2.8b2895bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas2.png
// module id = 1773
// module chunks = 0